import { observer } from "mobx-react-lite";
import LatexEditor from "../common/LatexEditor/LatexEditor";
import { Divider } from "@mui/material";
import ImageUpload from "../ImageUpload/ImageUpload";
import React, { useState } from "react";
import { uploadFilesService } from "../../services/UploadFilesService";
import { snackbarStore } from "../../mobx/ui/SnackbarStore";
import { useFormContext } from "react-hook-form";

interface QuestionEditorWithImagesProps {
	controllerName: string;
	editorTitle: string;
	displayTitle: string;
	height: string;
}

export default observer(function ({
	controllerName,
	editorTitle,
	displayTitle,
	height,
}: QuestionEditorWithImagesProps) {
	const { setValue, getValues } = useFormContext();
	const [pendingImages, setPendingImages] = useState<Record<string, string>>({});

	const handleImageUpload = async (files: FileList) => {
		try {
			const { filename, download } = await uploadFilesService.importImage(files!, () => {});
			setValue(controllerName, (getValues(controllerName) || "") + `\n<br />` + `\n{%%${filename}%%}`);
			setPendingImages((prevState) => ({
				...prevState,
				[`{%%${filename}%%}`]: `<img style="max-width: 315px;" src=${download} alt="Картинка в редакторе" />`,
			}));
			snackbarStore.notifySuccess("Картинка загружена!");
		} catch (e) {
			snackbarStore.notifyError("Не удалось загрузить картинку");
		}
	};

	return (
		<>
			<LatexEditor
				controllerName={controllerName}
				editorTitle={editorTitle}
				displayTitle={displayTitle}
				height={height}
				pendingImages={pendingImages}
			/>
			<Divider sx={(theme) => ({ margin: theme.spacing(2, 0) })} />
			<ImageUpload editorName={controllerName} onLoad={handleImageUpload} />
		</>
	);
});
